import { render, staticRenderFns } from "./registrationStudentView.vue?vue&type=template&id=eba4ad5e&scoped=true&"
import script from "./registrationStudentView.vue?vue&type=script&lang=js&"
export * from "./registrationStudentView.vue?vue&type=script&lang=js&"
import style0 from "./registrationStudentView.vue?vue&type=style&index=0&id=eba4ad5e&prod&lang=scss&scoped=true&"
import style1 from "./registrationStudentView.vue?vue&type=style&index=1&id=eba4ad5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba4ad5e",
  null
  
)

export default component.exports